<template>
  <div class="row">
    <div class="col-md-2">
      <input v-show="!recordData.isPrimary" type="checkbox" v-model="isChecked" class="custom-checkbox" />
    </div>
    <div class="col-md-2 custom-data text-wrap text-break">
      <span>{{ recordData.phoneTypeName }}</span>
    </div>
    <div class="col-md-4 custom-data text-wrap text-break">
      <span>{{ recordData.phoneNo }}</span>
      <span v-if="recordData.extension !== ''"> x{{ recordData.extension }}</span>
    </div>
    <div class="col-md-2 text-wrap text-break">
      <span v-show="recordData.isPrimary">(primary)</span>
    </div>
    <div class="col-md-2 text-wrap text-break">
      <a href="#" @click="editItem">edit</a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'contact-phone-record',
  props: {
    recordData: Object
  },
  computed: {
    isChecked: {
      get() {
        return this.recordData.isChecked
      },
      set(value) {
        this.$emit(
          'itemChecked',
          this.recordData,
          value
        )
      }
    }
  },
  methods: {
    editItem() {
      this.$emit('editItem', this.recordData)
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-data {
  text-align: left;
}
</style>
